import React from "react";
import {
    StyledModal,
    StyledModalBody,
    StyledModalFooter,

} from "../../../Styling/styledModal/styledModals";
import { BfButtonBlue, BfButtonBlueSecondary } from "../../../Styling/styledForm/styledBlueForm";

export const NotFinishedModal = (props) => {
    const { dialogVisible, cancelHandler, acceptHandler } = props.notFinishedModal;

    const messages = props.notFinishedModal.messages;

    const handleOkClick = () => {
        acceptHandler();
      };

    const handleCancelClick = () => {
        cancelHandler();
      };
      
    return (

        <StyledModal centered show={true} onHide={handleCancelClick}>

            <StyledModalBody>
                <h4 style={{color: '#ff0f0f'}}><b>{messages.notFinishedHeader}</b></h4>
                <p style={{whiteSpace: "pre-line"}}>{messages.notFinishedP}</p>
            </StyledModalBody>
           
            <StyledModalFooter>
                <BfButtonBlue variant="primary" onClick={handleCancelClick}>
                    {messages.md_Cancel}
                </BfButtonBlue>

                <BfButtonBlueSecondary textAsBorder onClick={handleOkClick}>
                    {messages.md_Ok}
                </BfButtonBlueSecondary>
            </StyledModalFooter>

        </StyledModal>
    );
};